// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import Request from './request';

async function fetch(data) {
  return Request('get', "api/shop-cost-analyze/index", data);
}

async function fetchOne(id) {
  return Request('get', "api/shop-cost-analyze/view/"+id);
}

async function fetchMaterial(data) {
  return Request('get', "api/shop-cost-analyze/material-analyze", data);
}

async function fetchMaterialDetail(data) {
  return Request('get', "api/shop-cost-analyze/material-analyze-detail", data);
}
// 批量导出
async function batchDetailExports(data){
  store.dispatch("fullscreenLoading")
  const response = await Request('get',"api/shop-cost-analyze/export",data)
  if(response.data && response.data.status.isOK()){
      snackbar.info(i18n.t("Export.recordedHint"))
  }
  store.dispatch("fullscreenLoadingStop")
  return response
}

// 明细导出
async function detailExports(id){
  store.dispatch("fullscreenLoading")
  const response = await Request('get',"api/shop-cost-analyze/export-detail?id=" + id)
  if(response.data && response.data.status.isOK()){
      snackbar.info(i18n.t("Export.recordedHint"))
  }
  store.dispatch("fullscreenLoadingStop")
  return response
}

// 门店货品损耗导出
async function Exports(data){
  store.dispatch("fullscreenLoading")
  const response = await Request('get',"api/shop-cost-analyze/export-for-material", data)
  if(response.data && response.data.status.isOK()){
      snackbar.info(i18n.t("Export.recordedHint"))
  }
  store.dispatch("fullscreenLoadingStop")
  return response
}

async function addShopCostAnalyze(data){
  return  Request('post',"api/shop-cost-analyze/add-shop-cost-analyze",data)
}

export default {
  fetch,
  fetchOne,
  batchDetailExports,
  detailExports,
  fetchMaterial,
  fetchMaterialDetail,
  Exports,
  addShopCostAnalyze,
};